export const browserStorage = () => ({
  getItem: window.localStorage.getItem.bind(localStorage),
  setItem: window.localStorage.setItem.bind(localStorage),
});
